import React from "react";
import {connect} from "react-redux";
import ContactUser from "./ContactUser";
import {modalsSelector} from "../../modules/Modals/Selectors";

import {useEffect} from "react";
import {createPortal} from "react-dom";

const Portal = ({children}) => {
  const root = document.getElementById("root");
  const mount = document.getElementById("portal-root");
  const el = document.createElement("div");
  el.classList.add("modal-root");

  useEffect(() => {
    root.style.filter = "blur(2px)";
    root.style.overflow = "hidden";

    mount.appendChild(el);
    return () => {
      root.style.filter = "";
      root.style.overflow = "";
      mount.removeChild(el);
    };
  }, [el, mount]);

  return createPortal(children, el);
};

const MODAL_COMPONENTS = {
  CONTACT_USER : ContactUser,
};

const ModalRoot = (props) => {
  const {modals} = props;
  if (!modals || modals.length < 1) return null;

  return (
    <Portal>
      {modals.map((modal) => {
        const SpecificModal = MODAL_COMPONENTS[modal.modalType];

        return (
          <SpecificModal {...modal.modalProps} key={modal.id} id={modal.id} />
        );
      })}
    </Portal>
  );
};

const mapStateToProps = (state) => ({
  modals: modalsSelector(state),
});

export default connect(mapStateToProps)(ModalRoot);
